import type { BulkCreateTimeOffRowPayload, TimeOffStatus, TimeOffType } from '../../../api/timeOff';
import type { CompanyHoliday } from '../../../api/companyHolidays';
import { nextAllDayEnd, toApiIso } from './timeOffDateUtils';
import { buildHolidayLookup, excludeHolidaysFromTimeOffRange } from './timeOffHolidayExclusion';

export function rowsAfterHolidayExclusion(
  startLocal: Date,
  endLocal: Date,
  isAllDay: boolean,
  holidays: CompanyHoliday[],
  meta: {
    type: TimeOffType;
    status?: TimeOffStatus;
    notes?: string | null;
  }
): BulkCreateTimeOffRowPayload[] {
  const lookup = buildHolidayLookup(holidays);
  const spans = excludeHolidaysFromTimeOffRange(startLocal, endLocal, isAllDay, lookup);
  return spans.map((span) => ({
    type: meta.type,
    startUtc: toApiIso(span.startLocal, span.isAllDay),
    endUtc: toApiIso(span.isAllDay ? nextAllDayEnd(span.startLocal) : span.endLocal, span.isAllDay),
    isAllDay: span.isAllDay,
    notes: meta.notes ?? null,
    status: meta.status
  }));
}
